import axios from "axios";

const module = 'dispatch-orders'

const state = {
    tags: [],
    untagged: {orders: [], pagination: {}},
    days: 30,
    filters: {platform: [], created_at: [], status: []},
    loading: false,
}

const getters = {
    getTags: state => {
        return state.tags
    },
    getUntagged: state => {
        return state.untagged
    },
    getDays: state => {
        return state.days
    },
    getFilters: state => {
        return state.filters
    },
    getLoading: state => {
        return state.loading
    },
}

const actions = {
    asyncFetchData: async (context, payload = {}) => {
        context.commit('setLoading', true);
        const days = payload.days || context.state.days;
        const filters = payload.filters !== undefined ? payload.filters : context.state.filters;
        return await axios.post(`${context.rootGetters['settings/getUrl']}${module}`,
            {
                'days': days,
                'page': payload.page || 1,
                'itemsPerPage': payload.itemsPerPage || 25,
                'filters': filters,
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        ).then(res => {

            context.commit('setTags', res.data.tags);
            context.commit('setUntagged', res.data.untagged);
            context.commit('setDays', res.data.days);
            context.commit('setFilters', filters);
            return res.data;

        }).catch(err => {
            console.log("errore", err);
        }).finally(() => {
            context.commit('setLoading', false);
        });

    },
    destroyData: (context) => {
        context.commit('setTags', []);
        context.commit('setUntagged', {orders: [], pagination: {}});
    },
    // rifetch mirato: solo se la board e' gia' popolata (view montata), stesso pattern di orders/updateFromSocket
    updateFromSocket: async (context) => {
        if (_.size(context.state.tags) > 0 || _.size(context.state.untagged.orders) > 0) {
            context.dispatch('asyncFetchData', {days: context.state.days, filters: context.state.filters});
        }
    },
}

const mutations = {
    setTags: (state, value) => {
        state.tags = value;
    },
    setUntagged: (state, value) => {
        state.untagged = value;
    },
    setDays: (state, value) => {
        state.days = value;
    },
    setFilters: (state, value) => {
        state.filters = value;
    },
    setLoading: (state, value) => {
        state.loading = value;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
